module.exports = __webpack_public_path__ + "static/media/questionIcon.88d592c1.svg";